module.exports = __webpack_public_path__ + "static/media/kolia_white.034d39f6.svg";